/*global define */
/*jshint devel:true*/
/**
 * Base Service Model collection
 */
define(
	'BaseServiceModelCollection',[
		'backbone',
		'BaseCollection',
		'BaseServiceModel'
	],
	function (Backbone, BaseCollection, BaseServiceModel) {
		'use strict';
		return BaseCollection.extend({
			className: 'BaseServiceModelCollection',
			model: BaseServiceModel
		});
	}
);

